module.exports = __webpack_public_path__ + "img/church.77597a87.svg";